(function (ws) {
    'use strict';

    ws.views.CustomerOnboardingUploads = Backbone.View.extend({

        events: {
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.uploadedFiles = this.$('.filesList');
            this.eventAgg.on('createAttachmentField', this.createAttachmentField.bind(this));
            this.hasBeenRendered = [];
            this.lastAssocQuestionMediaToDownload = {};
            this.filesStorage = {};
            this.prospectId = $('#prospectId').val();
            this.prospect = {prospectId: this.prospectId};
            this.noLabelAttachmentToUpload = [];
            this.noLabelAttachmentToDownload = [];
            this.$newFiles = this.$('.newFiles');
            this.eventAgg.on('deleteSelectedAttachment', this.deleteSelectedAttachment.bind(this));
            this.eventAgg.on('updateList', this.updateList.bind(this));
            this.eventAgg.on('resetList', this.resetList.bind(this));
            this.deleteSelectedAttachmentApi = new ws.models.deleteSelectedAttachment(this.prospect);
            this.selectFileLabel = this.$('.selectFileLabel').val();
            this.downloadFileLabel = this.$('.downloadFileLabel').val();
        },

        createAttachmentField: function (tabNumber, data, hasBeenRendered) {
            this.hasBeenRendered = hasBeenRendered;

            if (this.hasBeenRendered.indexOf(data.questionId) > -1) {
                return true;
            }

            let hasAssociation = data.associatedQuestions ? Object.keys(data.associatedQuestions).length ? 'hasAssoc' : '' : '';
            let mediaDownloadWithoutAssoc = !hasAssociation ? true : false;
            let hideLabel = data.isChild ? 'hidden' : '';
            let downloadLink = '';
            let downloadLinkWithoutAssoc = '';
            let required = 'MANDATORY' in data.validations ? data.validations.MANDATORY ? '*' : '' : '';
            let requiredText = required ? 'required' : '';

            if (hasAssociation) {
                this.lastAssocQuestionMediaToDownload = data.answers;
            }

            if (data.isChild) {
                if (Object.keys(this.lastAssocQuestionMediaToDownload).length) {
                    for (let [key, value] of Object.entries(this.lastAssocQuestionMediaToDownload)) {
                        downloadLink = `<a href="${value}" download><b>${this.downloadFileLabel}</b></a>`;
                    }

                    this.lastAssocQuestionMediaToDownload = {};
                } else {
                    hideLabel = '';
                }
            }

            if (mediaDownloadWithoutAssoc) {
                for (let [key, value] of Object.entries(data.answers)) {
                    downloadLinkWithoutAssoc = `<a href="${value}" download><b>${this.downloadFileLabel}</b></a>`;
                }
            }

            if (data.header) {
                this.addHeaderIfPresent(tabNumber, data);
            }

            let options = '';
            _.each(data.dropDown, option => {
                let selectedOption = option.selected ? 'selected' : '';

                if (option.name ? option.name.includes('default.lookup.option.name') : false) {
                    options += `<option value="${option.value}" ${selectedOption}>${$('.defaultSelect').val()}</option>`;
                } else {
                    options += `<option value="${option.value}" ${selectedOption}>${option.name}</option>`;
                }
            });

            let item = '';
            let inputButton = `<input type="button" onclick="${data.questionId}()" class="paperclip-attch button" value="${this.selectFileLabel}"></input>
                           <script>
                              function ${data.questionId}() {
                                 document.getElementById("${data.questionId}-button").click();
                              }
                           </script>
                           <input ${requiredText} id="${data.questionId}-button" data-address="${data.questionId}" class="attachmentUpload" type="file" name="manualAttachments" accept="application/vnd.ms-excel, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document,  application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, image/*">
                           <span class="error customError hidden" style="position:relative"></span>`;

            let mediaUpload = `<select class='document-select' id='${data.questionId}'>
                                    ${options}
                                </select>`;

            if (data.fieldType === 'ATTACHMENTTYPE_SINGLE') {
                item = `<label class='label'>${data.question}</label>
                     <div class='lableSelectFiles'>
                        ${mediaUpload}
                        ${inputButton}
                     </div>`;
            } else if (data.fieldType === 'MEDIA_UPLOAD') {
                item = `<label class='label ${hideLabel}'>${data.question}${required}</label>
                     <div class='lableSelectFiles'>
                        ${inputButton}
                        ${downloadLink}
                     </div>`;
                this.noLabelAttachmentToUpload.push(data.questionId);

            } else if (data.fieldType === 'MEDIA_DOWNLOAD') {
                item = `<label class='label'>${data.question} ${downloadLinkWithoutAssoc}</label>`;
                this.noLabelAttachmentToDownload.push(data.questionId);
            }

            //First append div
            let doccRow = `<div class="small-12 columns ${data.questionId}"></div>`;
            $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(doccRow);

            //append Data to div
            $('.customer-onboarding > .customer-documentAttachments').clone().appendTo(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row .${data.questionId}`);
            $(`.comp-tabs .customer-documentAttachments`).removeClass('hidden');

            //append dynamic fields to same div
            $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row .${data.questionId}`).find('.attachment-dynamic').append(item);

            $('.existingFiles').hide();

            if (data.answers && data.fieldType !== 'MEDIA_DOWNLOAD') {
                let fieldName = data.questionId;
                this.filesStorage[fieldName] = data.answers;
                if (!hasAssociation) {
                    this.appendFileList(fieldName);
                }
            }

            if (data.fieldType === 'MEDIA_DOWNLOAD') {
                $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row .${data.questionId}`).find('.filesList').remove();
            }
        },

        addHeaderIfPresent: function (tabNumber, data) {
            let hasHeader = data.header ? data.header : '';
            if (hasHeader) {
                let addHeader = `<div class='small-12 column'><label class='${hasHeader} label'">${hasHeader}</label></div>`;
                $(`.customer-onboarding .tab-content[data-tab="${tabNumber}"] .row`).append(addHeader);
            }
        },

        /**
         * Updating the list of uploaded files and
         * comparing exhisting files to eliminates Duplicates
         */
        updateList: function (e) {

            let className = e.currentTarget.offsetParent.classList[2];
            let isNewFile = false;
            let labelForAttachment = this.noLabelAttachmentToDownload.indexOf(className) > -1 || this.noLabelAttachmentToUpload.indexOf(className) > -1 ? false : true;

            // To get the file type attribute we must specify with the Javascript file handlers
            // suggest if you have any best practices
            var inputFiles = document.getElementById(`${className}-button`);
            var newFilesList = $(`.${className} #newFileList`)[0];
            var existingFileList = $(`.${className} #existingFileList`)[0];
            var existingFiles = $(`.${className} .existingFiles`);
            var existingFileName = $(`.${className} .existingFileNames`);

            newFilesList.innerHTML = '';
            existingFileList.innerHTML = '';
            this.$newFiles.hide();
            existingFiles.hide();
            if (this.noLabelAttachmentToUpload.indexOf(className) > -1) {
                this.filesStorage[className] = {};
            }

            let selectedDropDownAttachmentValue = '';
            let selectedDropDownAttachmentLabel = '';
            if (labelForAttachment) {
                selectedDropDownAttachmentValue = $(`#${className}`).val();
                selectedDropDownAttachmentLabel = $(`#${className} option:selected`).text();

                if (selectedDropDownAttachmentValue === '') {
                    return true;
                }

                let valueToDelete = '';
                _.each(this.filesStorage[className], function(key, value) {
                    if (value.split(':')[0].trim() === selectedDropDownAttachmentValue) {
                        valueToDelete =  value;
                    }
                });

                delete this.filesStorage[className][valueToDelete];
            }

            if (inputFiles.files.length > 0) {

                for (var i = 0; i < inputFiles.files.length; ++i) {
                    var flag = 0;

                    for (var j = 0; j < existingFileName.length; j++) {
                        var fileName = inputFiles.files.item(i).name;

                        //if file extension equals to xls or xlsx changing the temporary filename extension to XLT
                        //as we are getting xls files are coming with XLT extenstion
                        if (fileName.split('.').pop().toLowerCase() == 'xls' || fileName.split('.').pop().toLowerCase() == 'xlsx') {
                            fileName = fileName.substr(0, fileName.lastIndexOf('.')) + '.XLT';
                        }

                        //comparing the uploaded file with already uploaded files
                        //if equal setting flag to 1
                        if (fileName == existingFileName[j].value) {
                            existingFileList.innerHTML += '<li class="error-message">' + inputFiles.files.item(i).name + '</li>';
                            flag = 1;
                            existingFiles.show();
                        }
                    }

                    //if flag is not changed means its an new file and appending into newFile section
                    if (flag === 0) {
                        newFilesList.innerHTML += '<li>' + inputFiles.files.item(i).name + '</li>';
                        if (labelForAttachment) {
                            this.filesStorage[className][selectedDropDownAttachmentValue + ' : ' + inputFiles.files.item(i).name] = '';
                        } else {
                            this.filesStorage[className][inputFiles.files.item(i).name] = '';
                        }

                        this.$newFiles.show();
                        isNewFile = true;
                    }
                }

                if (isNewFile) {
                    this.appendFileList(className);
                    var myFormData = new FormData();
                    myFormData.append('file', inputFiles.files[0]);
                    myFormData.append('docType', $(`#${className}`).val());

                    var url = `/store/customeronboard/customerForm/save/${className}/${this.prospectId}?${CSRF}`;
                    $.ajax({
                        url: url,
                        enctype: 'multipart/form-data',
                        type: 'POST',
                        data: myFormData,
                        processData: false,
                        contentType: false,
                        success:function(res) {
                            console.log(res);
                        }.bind(this),
                        error: function () {
                            console.log('ERROR');
                        }.bind(this)
                    });
                }
            }
        },

        appendFileList: function (className) {
            let listOfFiles = '';
            let labelForAttachment = this.noLabelAttachmentToDownload.indexOf(className) > -1 || this.noLabelAttachmentToUpload.indexOf(className) > -1 ? false : true;
            let deleteButtonRequired = this.noLabelAttachmentToDownload.indexOf(className) > -1 ? false : true;

            _.each(this.filesStorage[className], function (key, value) {
                let label = labelForAttachment ? `<label>${value}</label>` : '';
                let addDeleteButton = deleteButtonRequired ? `<input type='button' value='Remove X' data-attached="${value}" class="qut-attachments-del-click" data-attachmentsKey="${key}" ></input>` : '';

                if (value.split(':').length > 1) {
                    let fileName = value.split(':')[0];
                    value = value.split(':')[1];
                    label = `<label>${fileName}</label>`;
                }

                let downloadButton = key !== '' ? `<a href="${key}" download><b>${value}</b></a>` : `<a><b>${value}</b></a>`;
                listOfFiles += `${label}
                              <p>
                                 ${downloadButton}
                                 &nbsp;<b>${addDeleteButton}</b>
                                 <input name="manualAttachmentFileNames" class="existingFileNames" value="${value}" type="hidden"/>
                              </p>`;
            });

            $(`.comp-tabs .${className} .filesList`).empty();
            $(`.comp-tabs .${className} .filesList`).append(listOfFiles);
        },

        resetList: function (e) {
            $(e.currentTarget).val('');
        },

        deleteSelectedAttachment: function (e) {
            let className = e.currentTarget.offsetParent.classList[2];
            let attachedField = $(e.currentTarget).data('attached');

            var dataPost = {
                questionID: className,
                attribute: {
                    code: attachedField.split(':')[0]
                }
            };

            globals.disableApp();
            $.ajax({
                url: globals.path.api.westcon.deleteAttachment + this.prospectId + '?' + CSRF,
                method: 'POST',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(dataPost)
            }).done((response) => {
                globals.enableApp();
                $('.serverErrors').html('');
                console.log('deleted');
            }).fail((jqXHR, exception) => {
                globals.enableApp();
                $('.serverErrors').html('');
                $('.serverErrors').html('Error :' + exception).removeClass('hidden');
            });

            delete this.filesStorage[className][attachedField];
            if (this.noLabelAttachmentToDownload.indexOf(className) === -1 || this.noLabelAttachmentToUpload.indexOf(className) === -1) {
                $(e.currentTarget).parent().parent().prev().remove();
            }

            $(e.currentTarget).parent().parent().remove();
        }
    });
})(westcon);
